import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Sidebar from "../components/Sidebar";
import LoaderUI from "../components/common/loader/index";
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, useLocation } from "react-router-dom";
import DocAssistHeader from "../components/DocAssistHeader/Header";
import Footer from "../components/Footer";
import { roleItems, timeout } from "../utils/constants";
import { logout, unauthorized, saveTempData } from "../context/actions/user";

const PrivateAssistRulesLayout = ({ children, className, allowedRoles }) => {
	const dispatch = useDispatch();
	const history = useHistory();
	const location = useLocation();
	let isLoading = useSelector(state => state.general.loading);
	let loggedIn = useSelector(state => state.user.loggedIn);
	let role = useSelector(state => state?.user?.user?.role);
	const roleIndex = roleItems?.indexOf(role);


	if (!loggedIn) history.push('/login');
	else if (roleIndex === 1 && ( location.pathname.includes("location") || location.pathname.includes("operator"))) {
		dispatch(unauthorized())
		history.push('/dashboard');
	}


	return (
		<>
		
			{<div className="main-wrapper d-flex flex-column flex-fill overflow-auto">
				<DocAssistHeader className={className} />
				<div className="d-flex flex-column flex-fill overflow-auto">
					<div className="inner-wrapper d-flex flex-fill overflow-auto" id="mainInner">
						<div className="right-wrapper d-flex flex-column flex-fill overflow-auto">
							{isLoading && <LoaderUI
								loader={isLoading}
								overlay={true}
								overlayRadius='rounded-0'
								size=""
							/>}
							{children}
						</div>
					</div>
					<Footer className="mt-auto text-center" />
				</div>
			</div>}
		</>
	)
};

PrivateAssistRulesLayout.propTypes = {
	/**
	 * Whether to display the navbar, or not.
	 */
	noNavbar: PropTypes.bool,
	/**
	 * Whether to display the footer, or not.
	 */
	noFooter: PropTypes.bool
};

PrivateAssistRulesLayout.defaultProps = {
	noNavbar: false,
	noFooter: false
};

export default PrivateAssistRulesLayout;
